namespace $.$$ {
	/**
	 * Main application component using mol_deck for tabbed page navigation
	 * The deck automatically creates tab switcher from item titles
	 */
	export class $eve_app extends $.$eve_app {}
}
